var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonExit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2E2E2E;\n      }\n\n      .cls-2 {\n        fill: #979797;\n      }\n\t  .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        filter: url(#Ellipse_174);\n      }\n\t  .cls-4 {\n        filter: url(#Ellipse_175);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_174",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#323a4f",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_175",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#323a4f",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4279",
    "data-name": "Group 4279",
    transform: "translate(8.838 6)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3",
    transform: "matrix(1.015, 0, 0, 1.015, -9.1, -6.3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_174-2",
    "data-name": "Ellipse 174",
    className: "cls-5",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3",
    transform: "matrix(1, 0, 0, 1, -8.84, -6)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_175-2",
    "data-name": "Ellipse 174",
    className: "cls-1",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18809",
    "data-name": "Group 18809"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3620",
    "data-name": "Rectangle 3620",
    className: "cls-2",
    width: 2,
    height: 20,
    rx: 1,
    transform: "translate(21.864 8.223) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3621",
    "data-name": "Rectangle 3621",
    className: "cls-2",
    width: 2,
    height: 20,
    rx: 1,
    transform: "translate(23.279 22.363) rotate(135)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonExit);
export default __webpack_public_path__ + "static/media/button_exit.85afd7b1fbcf042cf6b9dd624096053d.svg";
export { ForwardRef as ReactComponent };